import styled from 'styled-components'

import { fontWeight, color } from 'src/styles'
import { fontSize } from 'src/styles/fonts'

export const KeysRow = styled.div`
  display: flex;
  justify-content: center;

  & + & {
    margin-top: 1.6rem;
  }
`

export const Label = styled.div`
  font-size: ${fontSize.SMALL_EXTRA};
  font-weight: ${fontWeight.EXTRA};
  opacity: 0.25;
  color: ${color.BLACK};
  transition: opacity 250ms;
`

export const ButtonKey = styled.button`
  display: flex;
  align-items: center;

  & + & {
    margin-left: 1.6rem;
  }

  svg {
    margin-right: 0.8rem;
  }

  :hover > ${Label} {
    opacity: 1;
  }
`

export const SpaceKey = styled.span`
  width: 12.4rem;
  height: 4rem;
  line-height: 4rem;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: ${fontSize.SMALL_EXTRA};
  font-weight: ${fontWeight.EXTRA};
  color: #ab9f94;
  margin-right: 0.8rem;
`
